module.exports = __webpack_public_path__ + "img/icon_dtfl_qkl_1.eff51d29.png";